import { useUrlParam } from "@opendash/core";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { Project } from "../../../../js/parsegenerated";
import { ProjectContextProvider } from "../context/ProjectContext";
import { useProject } from "../hooks/useProject";
import { useProjects } from "../hooks/useProjects";
import { ProjectCard } from "./ProjectCard";

type Props = {
  parent?: Project;
  hideSubProjects?: boolean;
};

/**
 * Recursive view of a project with all sub projects that can be navigated to and back from.
 */
export const ProjectCardWrapper = observer((props: Props) => {
  const { project } = useProject();
  const { projects: subProjects } = useProjects(project, true);
  const [projectToShowId] = useUrlParam<string>(project.id, undefined); // used to navigate to sub project

  const activeSubProject = useMemo(
    () => subProjects.find((p) => p.id === projectToShowId),
    [projectToShowId, subProjects]
  );

  return (
    <>
      {(!activeSubProject || props.hideSubProjects) && (
        <ProjectCard
          parent={props.parent}
          hideSubProjects={props.hideSubProjects}
        />
      )}
      {activeSubProject && !props.hideSubProjects && (
        <ProjectContextProvider value={activeSubProject}>
          <ProjectCardWrapper parent={project} />
        </ProjectContextProvider>
      )}
    </>
  );
});
